<template>
    <div class="panel">
        <div class="table">
            <div class="row">
                <div class="title">
                    Third Party Acceptance Approved?
                </div>
                <div class="data">
                    {{ siteDetails.thirdPartyAcceptanceApproved }}
                </div>
                <div class="data" />
            </div>
            <div class="row spacer">
                <div class="title">
                    Monitoring Report Due Date
                </div>
                <div class="data">
                    {{ siteDetails.monitoringReportDueDate }}
                </div>
                <div class="data" />
            </div>

            <div class="row">
                <div class="title" />
                <div class="data bold">
                    Off-Site
                </div>
                <div class="data bold">
                    On-Site
                </div>
            </div>
            <div
                v-for="row in data"
                :key="row.title"
                class="row"
            >
                <div class="title">
                    {{ row.title }}
                </div>
                <div :class="'data ' + ( row.offsite === 'no' ? 'red' : '' )">
                    {{ row.offsite }}
                </div>
                <div :class="'data ' + ( row.onsite === 'no' ? 'red' : '' )">
                    {{ row.onsite }}
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

export default defineComponent({
    name: 'RiskManagement',
    components: {},
    props: {
        siteDetails: ESARSite
    },
    setup(props) {
        const onSiteData = props.siteDetails?.riskManagementData.find((x) => x.RMPLocation === 'OnSite');
        const offSiteData = props.siteDetails?.riskManagementData.find((x) => x.RMPLocation === 'OffSite');

        const setToNAIfNotSet = function (v: string | undefined): string {
            if (!v) {
                return 'Not Applicable';
            }
            return v;
        };

        const data = [
            { title: 'Is there an approved RMP in place?', offsite: setToNAIfNotSet(offSiteData?.approvedRMPInPlace), onsite: setToNAIfNotSet(onSiteData?.approvedRMPInPlace) },
            { title: 'DUA Exclusion', offsite: setToNAIfNotSet(offSiteData?.DUA), onsite: setToNAIfNotSet(onSiteData?.DUA) },
            { title: 'FAL Exclusion', offsite: setToNAIfNotSet(offSiteData?.FAL), onsite: setToNAIfNotSet(onSiteData?.FAL) },
            { title: 'Management Limit', offsite: setToNAIfNotSet(offSiteData?.managementLimit), onsite: setToNAIfNotSet(onSiteData?.managementLimit) },
            { title: 'Ecological Direct Soil Contact', offsite: setToNAIfNotSet(offSiteData?.ecologicalDirectSoilContact), onsite: setToNAIfNotSet(onSiteData?.ecologicalDirectSoilContact) },
            { title: 'Vapour Inhilation', offsite: setToNAIfNotSet(offSiteData?.vapourInhalation), onsite: setToNAIfNotSet(onSiteData?.vapourInhalation) },
            { title: 'Others', offsite: setToNAIfNotSet(offSiteData?.others), onsite: setToNAIfNotSet(onSiteData?.others) },
            { title: 'Administrative Controls', offsite: setToNAIfNotSet(offSiteData?.administrativeControl), onsite: setToNAIfNotSet(onSiteData?.administrativeControl) },
            { title: 'Exposure Barriers', offsite: setToNAIfNotSet(offSiteData?.exposureBarriers), onsite: setToNAIfNotSet(onSiteData?.exposureBarriers) },
            // { title: 'Monitoring Report Due Date (D-M-Y)', offsite: '2011', onsite: '2011' },
        ];

        return { data };
    }
});
</script>

<style lang="postcss" scoped>
.panel {
    .table {
        @apply flex flex-col;

        .row {
            @apply flex mb-2 capitalize;

            &.spacer {
                @apply mb-8;
            }
        }

        .title {
            @apply w-1/2 font-bold;
        }

        .data {
            @apply w-1/4;
        }

        .bold {
            @apply font-bold
        }

        .red {
            @apply text-red-600;
        }
    }
}
</style>
